/**
 * @generated SignedSource<<d1bb40d3f14284ac71e150506c3a9894>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AlertsMenuItemContent$data = {
  readonly opsgenie: {
    readonly savedSearches: {
      readonly createdByMe: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
      readonly sharedWithMe: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
    };
  };
  readonly " $fragmentType": "AlertsMenuItemContent";
} | null | undefined;
export type AlertsMenuItemContent$key = {
  readonly " $data"?: AlertsMenuItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertsMenuItemContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
},
v2 = {
  "kind": "ScalarField",
  "name": "alertSearchQuery"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "AlertsMenuItemContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "OpsgenieQuery",
        "kind": "LinkedField",
        "name": "opsgenie",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "OpsgenieSavedSearches",
              "kind": "LinkedField",
              "name": "savedSearches",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "sharedWithMe",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v0/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.savedSearches.sharedWithMe.id"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v1/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.savedSearches.sharedWithMe.name"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v2/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "opsgenie.savedSearches.sharedWithMe"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "createdByMe",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v0/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.savedSearches.createdByMe.id"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v1/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.savedSearches.createdByMe.name"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v2/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                      }
                    ]
                  },
                  "action": "LOG",
                  "path": "opsgenie.savedSearches.createdByMe"
                }
              ]
            },
            "action": "LOG",
            "path": "opsgenie.savedSearches"
          }
        ]
      },
      "action": "LOG",
      "path": "opsgenie"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "a105f985be669906c4ceff76a45b11bc";

export default node;
